(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearResultContributorNewController", LebaniegoYearResultContributorNewController);

        LebaniegoYearResultContributorNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "$http",
        "$state",
        "$mdSidenav",
        "$q",
        "entity",
        "LebaniegoYearResultContributor",
        "previousState",
        "toastr",
        "DateUtils",
    ]

    function LebaniegoYearResultContributorNewController(
        $rootScope,
        $timeout,
        $scope,
        $http,
        $state,
        $mdSidenav,
        $q,
        entity,
        LebaniegoYearResultContributor,
        previousState,
        toastr,
        DateUtils
    ) {
        var vm = this;

        vm.lebaniegoYearResultContributor = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearResultContributorParameters")
        );
        
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearResultContributor = Object.assign({}, vm.lebaniegoYearResultContributor);
            lebaniegoYearResultContributor.id = null;
            lebaniegoYearResultContributor.year = vm.lebaniegoYearResultContributor.year;
            lebaniegoYearResultContributor.sector = 'APORTANTE';
            vm.lebaniegoYearResultContributor.gFile = {
                id: vm.lebaniegoYearResultContributor.gFile
            };
            lebaniegoYearResultContributor.gFile = vm.lebaniegoYearResultContributor.gFile;
            LebaniegoYearResultContributor.save(lebaniegoYearResultContributor, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-result-contributor", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el aportante");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-result/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_APORTANTES')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearResultContributor.businessName = item.sectorBusinessName;
                vm.lebaniegoYearResultContributor.gFile = item.gFileId;
            }
        }
    }
})();